module.exports = __webpack_public_path__ + "img/cdgl_position_img.0bf6543c.png";